export const CREATEUSER = "CREATEUSER";
export const GETALLUSER = "GETALLUSER";
export const GETUSERBYNODEID = "GETUSERBYNODEID";
export const UPDATEUSER = "UPDATEUSER";

export const GET_ALL_ACL_USERS = "GET_ALL_ACL_USERS";

export const SETPASSWORD = "SETPASSWORD";
export const RESENDEMAIL = "RESENDEMAIL";

export const RESETPASSWORD = "RESETPASSWORD";

export const SEARCH_USER = "SEARCH_USER";
export const RESET_USERS = "RESET_USERS";
export const RESET_ACTUAL_USERS = "RESET_ACTUAL_USERS";

export const UPDATE_SUPER_USER = "UPDATE_SUPER_USER";


export const REGISTER_USER = "REGISTER_USER";

export const CHECK_USER = "CHECK_USER";

export const SUBMIT_ORDER_SUBS = "SUBMIT_ORDER_SUBS";

export const SUBMIT_SIGNUP_USER = "SUBMIT_SIGNUP_USER";

export const DELETEUSER = "DELETEUSER";

export const GETSUPPORTJSON = "GETSUPPORTJSON";

export const POSTFEEDBACK = "POSTFEEDBACK";


export const submitSignupUser = data => {
  return {
    type: SUBMIT_SIGNUP_USER,
    payload: data
  }
}


export const deleteUser = (data) => {
  return {
    type: DELETEUSER,
    payload: data
  }
}


export const submitOrderSubs = data => {
  return {
    type: SUBMIT_ORDER_SUBS,
    payload: data.data
  }
}

export const createuser = data => {
  return {
    type: CREATEUSER,
    payload:data
  };
};

export const setpassword = data => {
  return {
    type: SETPASSWORD,
    payload:data
  };
};

export const resetpassword = data => {
  return {
    type: RESETPASSWORD,
    payload:data
  };
};
export const resendemail = data => {
  return {
    type: RESENDEMAIL,
    payload:data
  };
};

export const updateuser = (data,op) => {
  return {
    type: UPDATEUSER,
    payload:data,
    optype:op
  };
};


export const updateSuperUser = (data,op) => {
  return {
    type: UPDATE_SUPER_USER,
    payload:data,
    optype:op
  };
};

export const getalluser = () => {
  return {
    type: GETALLUSER
  };
};

export const getSupportJson = () => {
  return {
    type: GETSUPPORTJSON,
    optype:"SUPPORT_JSON"
  };
};

export const postFeedBack = (data) => {
  return {
    type: POSTFEEDBACK,
    payload:data
  };
};

export const getallaclusers = (op) => {
  return {
    type: GET_ALL_ACL_USERS,
    optype:op
  };
};
export const getUserByNodeId = (data,op) => {
  return {
    type: GETUSERBYNODEID,
    payload:data,
    optype:op
  };
};

export const searchUser = (data,op) => {
  return {
    type: SEARCH_USER,
    payload:data,
    optype:op
  };
};

export const resetUsers = () => {
  return {
    type: RESET_USERS
  };
};



export const resetActualUsers = () => {
  return {
    type: RESET_ACTUAL_USERS
  };
};

export const registerUser = (data) => {
  return {
    type: REGISTER_USER,
    payload:data
  };
};

export const CheckUser = (data,op) => {
  return {
    type: CHECK_USER,
    payload:data,
    optype:op
  };
};
